<template>
    <div class="footer-root">
        <div class="socials">
            <a target="_blank" href="http://instagram.com/openmoviesapp">
                <i class="fab fa-instagram"></i>
            </a>
            <a target="_blank" href="http://github.com/rohitchai/openmovies">
                <i class="fab fa-github"></i>
            </a>
            <a target="_blank" href="http://twitter.com/openmovies1">
                <i class="fab fa-twitter"></i>
            </a>
        </div>
        <div class="footer">
            <a target="_blank" href="http://rohit.nl">
                Developed with <span>❤</span> by Rohit.️ 
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Footer'    
}
</script>

<style scoped>
    .socials a:link, .socials a:visited {
        color: #1b1919;
        font-size: 48px;
        margin-left: 10px;
        margin-right: 10px;
    }
    
    .socials {
        text-align: center;
        margin-bottom: 20px;
    }

    .footer {
        background-color: #1b1919;
        text-align: center;
        padding: 2.5px;
    }

    .footer a:link, .footer a:visited {
        color: #fff;
        text-decoration: none;
    }

    .footer a span {
        color: #db0000;
    }
</style>